/** Clears swipe-dismiss inline styles when Radix leaves a stale overlay/sheet in the DOM. */
export function cleanupNativeSheetChrome(): void {
  if (typeof document === "undefined") return;

  document
    .querySelectorAll<HTMLElement>(
      ".native-sheet-overlay-dismissing, [data-radix-dialog-overlay], [data-radix-alert-dialog-overlay]",
    )
    .forEach((el) => {
      const openDialog = document.querySelector(
        '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]',
      );
      if (openDialog) return;
      el.classList.remove("native-sheet-overlay-dismissing");
      el.style.opacity = "";
      el.style.pointerEvents = "";
      el.style.removeProperty("backdrop-filter");
    });

  document.querySelectorAll<HTMLElement>(".native-sheet-exit-locked").forEach((el) => {
    el.classList.remove(
      "native-sheet-exit-locked",
      "native-sheet-dismissing",
      "native-sheet-dragging",
      "native-sheet-expanded",
    );
    el.style.transform = "";
    el.style.opacity = "";
    el.style.pointerEvents = "";
  });

  const openDialog = document.querySelector(
    '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]',
  );

  document.querySelectorAll<HTMLElement>(".native-sheet-expanded").forEach((el) => {
    if (openDialog) return;
    el.classList.remove("native-sheet-expanded");
    el.style.transform = "";
  });

  document.body.style.pointerEvents = "";
  document.body.classList.remove("pointer-events-none");
}
